package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class WalmartLoginRequestInfo(
    val authorizationCode: String,
    val redirectUri: String,
    val reCaptchaToken: String? = null
)

@Serializable
@JsExport
internal data class WalmartLoginClientRequestInfo(
    val authorizationCode: String,
    val redirectUri: String,
    val reCaptchaToken: String? = null,
    val messageToken: String? = null
)